/** Testi schermo successo Wallapop (IT). */
export const wallapopItSuccessCopy = {
  searchPlaceholder: 'Cerca in Tutte le categorie',
  favorites: 'Preferiti',
  inbox: 'Inbox',
  you: 'Tu',
  sell: 'Vendi',
  mainTitle: 'Il prodotto è stato acquistato',
  secureLine: "L'acquirente ha già pagato il suo prodotto, il denaro è al sicuro.",
  cta: 'Ricevere fondi',
  tealSecureTitle: 'Acquisti sicuri',
  tealSecureBody:
    'Tutti i pagamenti di Wallapop sono criptati. Ciò è garantito dal nostro partner di fiducia Adyen, che dispone della tecnologia necessaria per verificare l\'accuratezza del denaro inviato e ricevuto.',
  tealSupportTitle: 'Il nostro supporto',
  tealSupportBody:
    'Potete contattarci 24 ore su 24 e aspettarvi una risposta entro 24 ore. Il nostro team esaminerà ogni problema e cercherà di trovare una soluzione. Il nostro team tratta ogni cliente con rispetto, quindi qualsiasi problema di prelievo o ricezione di denaro è considerato una priorità. Potete contattare uno dei nostri specialisti di chat per ottenere la risposta più rapida e informativa alla vostra domanda.',
};
